import { render, staticRenderFns } from "./case-notes.vue?vue&type=template&id=3c5e8f76"
import script from "./case-notes.vue?vue&type=script&lang=js"
export * from "./case-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports